/**
 * @generated SignedSource<<285a7ad723f1e2a3f49d8bcf2871b775>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefetchContainer_itemSearch$data = {
  readonly displayUriRef: string | null;
  readonly vanityUriRef: string | null;
  readonly " $fragmentType": "SbSharedRefetchContainer_itemSearch";
};
export type SbSharedRefetchContainer_itemSearch$key = {
  readonly " $data"?: SbSharedRefetchContainer_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedRefetchContainer_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRefetchContainer_itemSearch",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vanityUriRef",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayUriRef",
      "storageKey": null
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "f51adc6540bc7e32acc413a572e1ccaf";

export default node;
